import {UIType, MainMenuBackground, NavigationBackground} from "../../../ui/@const";


export default function getWorkspaceIconClass() {

    let defaultIconColorClass = "ui5-color-white"
    let selectedIconColorClass = ""

    switch (gd.ui.type) {
        case UIType.TEAMS:
        case UIType.CLICK_UP:

            defaultIconColorClass = "icon-color-default"
            selectedIconColorClass = "icon-color-selected"

            return {defaultIconColorClass, selectedIconColorClass}
        case UIType.TOP:
        case UIType.LEFT:
        default:

            const navigationBgColor: NavigationBackground = gd.session.me.settings.skin.navigation;

            switch (navigationBgColor) {
                // If gray skin needs to be colored differently
                case NavigationBackground.GRAY:
                    defaultIconColorClass = `icon-color-${navigationBgColor}`
                    selectedIconColorClass = `icon-color-${MainMenuBackground.GRAY}`
                    break
                case NavigationBackground.DARK:

                    if (gd.session.me.settings.skin.menu === MainMenuBackground.WHITE) {
                        defaultIconColorClass = `icon-color-dark-dark`
                        selectedIconColorClass = `icon-color-dark-${MainMenuBackground.WHITE}`
                    }

                    if (gd.session.me.settings.skin.menu === MainMenuBackground.GRAY) {
                        defaultIconColorClass = `icon-color-dark-dark`
                        selectedIconColorClass = `icon-color-dark-${MainMenuBackground.GRAY}`
                    }

                    if (gd.session.me.settings.skin.menu === MainMenuBackground.DARK) {
                        defaultIconColorClass = `icon-color-dark-${MainMenuBackground.DARK}`
                        selectedIconColorClass = `icon-color-dark-${MainMenuBackground.DARK}`
                    }
                    break
                default:

                    defaultIconColorClass = gd.ui.isDark ? `icon-color-${navigationBgColor}` : defaultIconColorClass

                    selectedIconColorClass = `icon-color-${navigationBgColor}`
            }

            return {defaultIconColorClass, selectedIconColorClass}
    }

}
